interface CustomPaletteColorOptions {
  main: string;
  focus: string;
}

import colors from "@/themes/base/colors";
import typography from "@/themes/base/typography";
import pxToRem from "@/themes/functions/pxToRem";

const { white, text, dark, secondary } = colors;
const { size } = typography;

const contained = {
  base: {
    backgroundColor: white.main,
    minHeight: pxToRem(40),
    color: text!.main,
    padding: `${pxToRem(10)} ${pxToRem(24)}`,

    "&:hover": {
      backgroundColor: white.main,
    },

    "&:active, &:active:focus, &:active:hover": {
      opacity: 0.85,
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(32),
    padding: `${pxToRem(6)} ${pxToRem(16)}`,
    fontSize: size.xs,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(47),
    padding: `${pxToRem(12)} ${pxToRem(28)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    backgroundColor: dark.main,

    "&:hover": {
      backgroundColor: dark.main,
    },

    "&:focus:not(:hover)": {
      backgroundColor: dark.focus,
    },
  },

  secondary: {
    backgroundColor: (secondary as CustomPaletteColorOptions).main,

    "&:hover": {
      backgroundColor: (secondary as CustomPaletteColorOptions).main,
    },

    "&:focus:not(:hover)": {
      backgroundColor: (secondary as CustomPaletteColorOptions).focus,
    },
  },
};

export default contained;
